// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputSection__input-d5680f {
  padding: 12px 16px;
  background: none;
  border: none;
  scrollbar-width: none;
}

.InputSection__input-placeholder-af1b99 {
  padding: 12px 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/InputSection/InputSection.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".input {\n  padding: 12px 16px;\n  background: none;\n  border: none;\n  scrollbar-width: none;\n}\n\n.input-placeholder {\n  padding: 12px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `InputSection__input-d5680f`,
	"input-placeholder": `InputSection__input-placeholder-af1b99`,
	"inputPlaceholder": `InputSection__input-placeholder-af1b99`
};
module.exports = ___CSS_LOADER_EXPORT___;
